import {
  bimSimConstructGetTree,
  bimSimConstructGTeeeiilmnt,
  bimSimConstructGetTimelineTree,
  bimSimConstructDeeelt,
  bimSimConstructObjectsDetail,
  BimSimConstructRoadwayList,
  bimSimConstructRoadwayDetailList,
  BimSimConstructObjectsDetail,
  BimSimConstructParkingDetail,
  BimSimConstructTransferPartDetail,
  BimSimConstructWorkPntsDetail,
  BimSimWorkingGrowDetail,
  BimSimWorkingPointsDetailPage,
  BimSimWorkingPointsDetailList,
  BimMlodelGetByWame,
  BimSimWorkingGetSimId,
  bimSimWorkingFlowDetail,
  BimSimWorkingDetail,
} from "@/api/api";
import { set } from "lodash";

const MapModal = () => import("@/components/common/mapModal/Index");
const importDataPage = () => import("./importDataPage.vue");
const programmeSimulation = () => import("./programmeSimulation.vue");
// import { programmeSimulations } from "./programmeSimulation.js";
import * as programmeSimulations from "./programmeSimulation.js";
// import * as programme from "../constructionProgramme/programme3.js";
import * as cuttingMap from "./cuttingMap.js";
import * as mapWork from "./trafficSimulation.js";

export default {
  components: {
    MapModal,
    importDataPage,
    programmeSimulation,
  },
  props: {
    sceneId: "",
  },
  data() {
    return {
      Timeline: {
        title: "全局模拟",
        id: "Timeline",
      },
      modalNode: {
        Timeline: {
          show: true,
          loading: false,
          // 样式配置 定位使用
          // style: "margin: 106px 0 0 -706px;",
          offset: {
            // 默认弹出层偏移
            // x: 106,
            // y: -376,
            x: 55,
            left: 5,
            // unit: "px", // 默认px
          },
          width: "250px",
          // auto 自适应
          // height: "500px", // 配置模态框中心高度
          height: `${document.querySelector("#mars3d-container").offsetHeight -
            50}px`,
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            id: "bimVideoCategoryTree", // id和ref使用的同一个
            name: "title", // 树的展示字段 默认name
            // 配置icon
            i_icon: {
              // level_1: "el-icon-video-play",
              // level_2: "el-icon-gis_dixingkaiwa",
              // level_3: "el-icon-gis_dixingkaiwa",
            },
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            // nodeClick 事件绑定
            // checkeArr: [],
            nodeClick: this.nodeClick,
            // checkBox: true,
            // checkBoxClick: this.checkBoxClick,
          },
        },
      },
      activeName: "first",
      importDataPageShow: false,
      programmeSimulationShow: false,
      animation: {
        type: "2",
        selectTime: [],
        totalTime: "",
        company: "second",
        animationData: [],
        groups: [],
      },
      initCustomDate: "",
      maxTime: "",
      entityList: [],
      roadwayIdList: [],
      SimId: null,
      loading: false,
      newEntityIdList: [],
      cross_group_type: "", //区分工点working和全局global
      working_pointData: null,
      lastTimeGroup: null,
      initialization: true,
      timer: [],
      executeQueue: [],
      modelId_list: [],
      suspendedShow: false, //是否暂停
      startBtnShow: false,
      mouseUpShow: false,
      workingPointInfo: null,
      crossGroupSimId: null,
      mouseUpTime: null,
      workingShow: false,
      tilesetLayer: null,
      datadata: null,
      aaaaaa: [
        {
          name: "阶段一",
          start: "2022-06-01",
          end: "2023-01-01",
          list: [
            {
              id: "f8bf09f5fceaea80e1f864a1b48938bf",
              start: "2022-06-01",
              end: "2023-01-01",
            },
            {
              id: "0ae3f79a30234b6c45a6f7d298ba1310",
              start: "2022-06-10",
              end: "2023-01-01",
            },
            {
              id: "eb0ecdb070a1a0ac46de0cd733d39cf3",
              start: "2022-06-20",
              end: "2023-01-01",
            },
            {
              id: "b5baa9c23ac3e015ad287b17a3d4afa3",
              start: "2022-06-27",
              end: "2023-01-01",
            },
            {
              id: "6f4920ea25403ec77bee9efce43ea25e",
              start: "2022-07-10",
              end: "2023-01-01",
            },
            {
              id: "b5f1e8fb36cd7fbeb7988e8639ac79e9",
              start: "2022-07-20",
              end: "2023-01-01",
            },
            {
              id: "e0688d13958a19e087e123148555e4b4",
              start: "2022-08-10",
              end: "2023-01-01",
            },
            {
              id: "7180cffd6a8e829dacfc2a31b3f72ece",
              start: "2022-08-20",
              end: "2023-01-01",
            },
          ],
        },
      ],
      // advanceTime: [
      //   {
      //     type: "day",
      //     num: 1,
      //   },
      //   {
      //     type: "week",
      //     num: 7,
      //   },
      //   {
      //     type: "month",
      //     num: 30,
      //   },
      // ],
      // doubleSpeed: "month",
      doubleSpeed: "week",
      isPlaying: true,
      silentTimeOutCounter: 1000,
      positionsAll: [],
      modelID: "3d3ef7a7-0b74-4c1b-8073-2db9960b3333",
      project_endTime: null,
      project_startTime: null,
    };
  },
  watch: {
    cross_group_type(v) {
      if (v == "working") {
        this.Timeline.title = "工点模拟";
      } else {
        this.Timeline.title = "全局模拟";
      }
    },
  },
  methods: {
    getData() {
      if (this.cross_group_type == "working") {
        //工点
        this.startBtnShow = true;
        BimSimWorkingGrowDetail({
          simId: window.sessionStorage.getItem("crossGroupSimId"),
        }).then((res) => {
          if (res.status == 200 && res.data.code == 200 && res.data.data) {
            // 二级分组新增编辑删除
            const operateGroupingList = [
              {
                i_icon: "small-operation-btn el-icon-video-play",
                click: (e) => this.openSimulation(e),
              },
            ];
            res.data.data.operate = operateGroupingList;
            let obj = [res.data.data];
            if (obj[0].children.length > 0) {
              obj[0].children.forEach((item) => {
                if (item.children.length > 0) this.recursion(item.children);
              });
            }

            this.modalNode.Timeline.content.treeDataJson = obj;
          }
        });
      } else {
        //全局  "global"
        this.startBtnShow = false;
        bimSimConstructGetTree({
          // SceneId: this.sceneId, //场景ID
          projectid: window.sessionStorage.getItem("nowProjectId"),
          // Simid: this.$route.params.simId,
        })
          .then((res) => {
            var data = [];
            res.data.data.forEach((el) => {
              if (el.id == window.sessionStorage.getItem("crossGroupSimId")) {
                data.push(el);
              }
            });
            // 二级分组新增编辑删除
            const operateGroupingList = [
              {
                i_icon: "small-operation-btn el-icon-video-play",
                click: (e) => this.openSimulation(e),
              },
              // {
              //   i_icon: "small-operation-btn el-icon-edit",
              //   click: (e) => this.editFun(e),
              // },
              // {
              //   i_icon: "small-operation-btn el-icon-delete",
              //   click: (e) => this.deleteSimulation(e),
              // },
            ];
            if (data.length > 0) {
              data.forEach((item) => {
                item.operate = operateGroupingList;
                if (item.children.length > 0) {
                  item.children.forEach((el) => {
                    if (el.title == "工点") {
                      this.recursion2(el.children);
                    } else if (el.title == "交组对象") {
                      this.recursion2(el.children, true);
                    }
                  });
                }
              });
            }

            this.modalNode.Timeline.content.treeDataJson = data;

            this.openSimulation(
              this.modalNode.Timeline.content.treeDataJson[0]
            );
            setTimeout(() => {
              this.$GLOBAL.map.setCameraView({
                lat: 23.03492906,
                lng: 113.84067202,
                alt: 41753.7,
                heading: 228.6,
                pitch: -67.5,
              });
            }, 2500);
          })
          .catch((error) => {
            console.log(error);
            this.$notify({
              title: "失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          });
      }
    },
    // 递归处理树数据
    recursion(data) {
      data.forEach((item) => {
        item.title_parent = item.title;
        // item.title = item.code;
      });
    },
    recursion2(data, uniyt = false) {
      let threeObj;
      if (data.length) {
        data.forEach((item) => {
          if (item?.children.length) {
            this.recursion2(item.children, uniyt);
          } else {
            if (uniyt) {
              threeObj = [
                {
                  i_icon: "las la-map-marked",
                  click: (e) => {
                    if (e.id == 426512392536133) window.open("ChuanCha://");
                  },
                },
              ];
            } else {
              threeObj = [
                {
                  i_icon: "las la-exchange-alt",
                  click: (e) => this.toWorkingPoint(e),
                },
              ];
            }

            data.forEach((item) => {
              item.operate = threeObj;
            });
          }
        });
      }
    },
    toWorkingPoint(e) {
      console.log(e);
      BimSimConstructWorkPntsDetail({
        EntityId: e.entityId,
      }).then((res) => {
        this.$GLOBAL.map.flyToPositions([
          [res.data.data.startX, res.data.data.startY, 300],
          [res.data.data.endX, res.data.data.endY, 300],
        ]);
      });
      BimSimWorkingGetSimId({
        projectid: window.sessionStorage.getItem("nowProjectId"),
        WorkingName: e.title,
      }).then((res) => {
        if (res.data.data) {
          this.workingPointInfo = res.data.data;
          this.crossGroupSimId = window.sessionStorage.getItem(
            "crossGroupSimId"
          );

          window.sessionStorage.setItem("cross_group_type", "working");
          this.cross_group_type = "working";
          window.sessionStorage.setItem(
            "crossGroupSimId",
            this.workingPointInfo.simId
          );
          this.$eventBus.$emit("resetMenu");
          this.getData();
          this.$notify({
            title: "成功",
            message: "进入工点模式",
            type: "success",
            duration: 1000,
            offset: 320,
          });
          this.workingShow = true;
          this.programmeSimulationShow = false;
          programmeSimulations.reset();
          this.Timeline.title = "工点模拟";
        }
      });
    },
    exitWorking() {
      this.workingPointInfo = null;
      window.sessionStorage.setItem("crossGroupSimId", this.crossGroupSimId);
      window.sessionStorage.setItem("cross_group_type", "global");
      this.cross_group_type = "global";
      this.$notify({
        title: "成功",
        message: "退出工点模式",
        type: "success",
        duration: 1000,
        offset: 320,
      });
      this.workingShow = false;
      this.$eventBus.$emit("resetMenu");
      this.getData();
      this.programmeSimulationShow = false;
      this.Timeline.title = "全局模拟";
    },
    handleClick(tab, event) {
      console.log(tab, event);
    },
    videoSurveilClick() {
      programmeSimulations.reset();
      this.$emit("closeTimeline");
    },
    importData() {
      this.importDataPageShow = true;
    },
    nodeClick(e) {
      console.log(e);
      if (this.cross_group_type == "working") {
        BimSimWorkingPointsDetailPage({
          pointsId: e.pointsId,
          pageSize: 2,
        }).then((res) => {
          console.log(res);
          let p1 = programmeSimulations.getData(
            res.data.data.rows[0].x,
            res.data.data.rows[0].y,
            300
          );
          let p2 = programmeSimulations.getData(
            res.data.data.rows[0].x,
            res.data.data.rows[1].y,
            300
          );
          this.$GLOBAL.map.flyToPositions([p1, p2]);
        });
      } else {
        if (e.entityType == "object" || e.entityType == "roadway") {
          BimSimConstructObjectsDetail({
            EntityId: e.entityId,
          }).then((res) => {
            this.$GLOBAL.map.flyToPositions([
              [res.data.data.startPointX, res.data.data.startPointY, 300],
              [res.data.data.endPointX, res.data.data.endPointY, 300],
            ]);
          });
        } else if (e.entityType == "parking") {
          // 停车
          BimSimConstructParkingDetail({
            EntityId: e.entityId,
          }).then((res) => {
            this.$GLOBAL.map.flyToPoint([
              res.data.data.x,
              res.data.data.y,
              300,
            ]);
          });
        } else if (e.entityType == "transfer") {
          // 交通转换
          BimSimConstructTransferPartDetail({
            EntityId: e.entityId,
          }).then((res) => {
            this.$GLOBAL.map.flyToPositions([
              [res.data.data.startX, res.data.data.startY, 300],
              [res.data.data.endX, res.data.data.endY, 300],
            ]);
          });
        } else if (e.entityType == "workingPoints") {
          // 工点转换
          BimSimConstructWorkPntsDetail({
            EntityId: e.entityId,
          }).then((res) => {
            this.$GLOBAL.map.flyToPositions([
              [res.data.data.startX, res.data.data.startY, 300],
              [res.data.data.endX, res.data.data.endY, 300],
            ]);
          });
        }
      }
    },
    openSimulation(e) {
      // programmeSimulations.getData2();
      // return;

      // return;
      if (this.cross_group_type == "working") {
        // const camera = this.$GLOBAL.map.getCameraView();
        // console.log(JSON.stringify(camera));
        // return;
        this.$GLOBAL.map.setCameraView({
          lat: 22.87415782,
          lng: 113.66826366,
          alt: 324.2,
          heading: 17.2,
          pitch: -26.1,
        });
        // this.openTime();
        // return;
        programmeSimulations.reset();
        this.loading = true;
        this.programmeSimulationShow = false;
        BimSimWorkingDetail({
          simId: window.sessionStorage.getItem("crossGroupSimId"),
        }).then((value) => {
          this.project_endTime = value.data.data[0].endTime.split(" ")[0];
          this.project_startTime = value.data.data[0].startTime.split(" ")[0];
          BimMlodelGetByWame({
            projectid: window.sessionStorage.getItem("nowProjectId"),
            modelName: value.data.data[0].name,
          }).then((value_data) => {
            console.log(value_data, "value_data");
            this.modelID = value_data.data.data.embsId;
            BimSimWorkingGrowDetail({
              simId: window.sessionStorage.getItem("crossGroupSimId"),
            }).then(async (res) => {
              this.programmeSimulationShow = true;
              this.loading = false;

              if (res.status == 200 && res.data.code == 200) {
                let groups = [];
                let animationData = [];
                let list = [];
                // fetch(
                //   process.env.VUE_APP_PROJECT_BASE_URL +
                //     process.env.VUE_APP_MODEL_BASE_PORT +
                //     res.data.data.modelUrl
                // )
                //   .then((response) => response.json())
                //   .then((json) => console.log(json, "6666666666"));
                this.working_pointData = res.data.data.children;
                res.data.data.children.forEach((el, index) => {
                  groups.push({
                    id: index,
                    content: el.title,
                  });

                  list.push(this.getPoints(el.children[0], index));
                });
                const listAll = await Promise.all(list);
                this.modelId_list = [];
                this.working_pointData.forEach((el) => {
                  el.children.forEach((va) => {
                    this.modelId_list.push({
                      modelId: va.modelId,
                      simMethod: va.simMethod,
                      name: va.code,
                    });
                  });
                });
                this.working_pointData.forEach((el, index) => {
                  el.children.forEach((element) => {
                    animationData.push({
                      id: element.id,
                      group: index,
                      content: element.code,
                      start: element.startTime,
                      end: element.endTime,
                      pointsId: element.pointsId,
                      positiList: element.positiList
                        ? element.positiList
                        : null,
                      modelId: element.modelId,
                      simMethod: element.simMethod,
                      screenplay: [
                        {
                          id: element.id,
                          type: element.simMethod,
                          component: [element.code], // 构件数组
                          screenplayId: value_data.data.data.embsId,
                        },
                      ],
                    });
                  });
                });

                console.log(animationData, "animationData");
                this.animation.animationData = animationData;
                this.animation.groups = groups;
                this.initCustomDate = value.data.data[0].startTime;
                this.maxTime = value.data.data[0].endTime;
                setTimeout(() => {
                  this.$refs.programmeSimulation.getData();
                }, 300);
              }
            });
          });
        });
      } else {
        this.SimId = e.id;
        this.$store.commit("sendSimId", e.id);
        this.$emit("constructionUpdateData");
        this.programmeSimulationShow = false;
        programmeSimulations.reset();
        this.loading = true;
        bimSimConstructGetTimelineTree({
          SimId: e.id,
        })
          .then(async (res) => {
            this.entityList = res.data.data;

            // this.modalNode.Timeline.head.fold.state = false;
            this.$emit("shutDownLeftDrawer");

            this.animation.groups = [];
            this.animation.animationData = [];
            let groups = [];
            let animationData = [];
            this.roadwayIdList = [];
            // let t1 = new Date().getTime();
            // console.log(
            //   "*********************************************************************"
            // );
            // console.log(new Date().getSeconds());
            // let indexss;
            // for (let i = res.data.data.length - 1; i >= 0; i--) {
            //   if (res.data.data[i].entityType == "roadway") {
            //     indexss = i;
            //     break;
            //   }
            // }
            let list = [];
            res.data.data.forEach((el, index) => {
              el.entityIdList = [];
              if (el.entityType == "object" || el.entityType == "roadway") {
                groups.push({
                  id: index,
                  // content: el.detail.name + el.detail.sectionName,
                  content: el.detail.name,
                });
              }

              if (el.entityType == "roadway") {
                this.roadwayIdList.push(el.entityId);

                // BimSimConstructRoadwayList({
                //   EntityId: el.entityId,
                //   Level: 1,
                // }).then((value) => {
                //   value.data.data.forEach((element, index) => {
                //     // if (index < 1) el.entityIdList.push(element);
                //     element.Level = 1;
                //     el.entityIdList.push(element);
                //   });
                // });
                // BimSimConstructRoadwayList({
                //   EntityId: el.entityId,
                //   Level: 2,
                // }).then((value) => {
                //   value.data.data.forEach((element, index) => {
                //     // if (index < 1) el.entityIdList.push(element);
                //     element.Level = 2;
                //     el.entityIdList.push(element);
                //   });
                // });
                list.push(this.getDxp(el.entityId, 3, index));
              }
            });

            // this.$GLOBAL.map.flyToPositions([
            //   [
            //     res.data.data[0].detail.startPointX,
            //     res.data.data[0].detail.startPointY,
            //     300,
            //   ],
            //   [
            //     res.data.data[res.data.data.length - 2].detail.endPointX,
            //     res.data.data[res.data.data.length - 2].detail.endPointY,
            //     300,
            //   ],
            // ]);
            this.$GLOBAL.map.setCameraView({
              lat: 23.03492906,
              lng: 113.84067202,
              alt: 41753.7,
              heading: 228.6,
              pitch: -67.5,
            });
            // 所有请求都已完成，直接返回或处理 res
            const listAll = await Promise.all(list);
            console.log(this.newEntityIdList, "this.newEntityIdList;");

            setTimeout(() => {
              // return;
              res.data.data.forEach((el, index) => {
                el.children.forEach((element) => {
                  animationData.push({
                    id: element.id,
                    group: index,
                    content: element.title,
                    start: element.startTime,
                    end: element.endTime,
                    entityId: element.entityId,
                    startLng: el.detail.startPointX,
                    startLat: el.detail.startPointY,
                    endLng: el.detail.endPointX,
                    endLat: el.detail.endPointY,
                    entityType: el.entityType,
                    // entityIdList: el.entityIdList,
                  });
                });
              });

              let animationData3 = [];
              setTimeout(() => {
                res.data.data.forEach((el, index) => {
                  if (el.entityType == "roadway") {
                    if (el.entityIdList.length) {
                      el.entityIdList[0].entityType = el.entityType;
                    }

                    animationData3 = animationData3.concat(
                      JSON.parse(JSON.stringify(el.entityIdList))
                    );
                  }
                });
              }, 50);

              setTimeout(() => {
                animationData3.forEach((item) => {
                  animationData.push({
                    id: item.id,
                    group: "laneGroup",
                    content: "",
                    // content: `${item.identity.split("-")[0]}-${
                    //   item.identity.split("-")[1]
                    // }`,
                    start: item.startTime,
                    end: item.endTime,
                    entityId: item.entityId,
                    entityType: animationData3[0].entityType,
                    lane: item,
                    type: "point",
                    Level: item.Level,
                  });
                });
                this.animation.animationData = animationData;
                groups.push({
                  id: "laneGroup",
                  content: "",
                  visible: false,
                });
                this.animation.groups = groups;

                this.initCustomDate = animationData[0].start;
                this.maxTime = animationData[animationData.length - 1].end;

                setTimeout(async () => {
                  let list = [];
                  res.data.data.forEach((el, index) => {
                    el.entityIdList = [];
                    if (el.entityType == "roadway") {
                      // BimSimConstructRoadwayList({
                      //   EntityId: el.entityId,
                      //   Level: 1,
                      // }).then((value) => {
                      //   value.data.data.forEach((element, index) => {
                      //     element.Level = 1;
                      //     el.entityIdList.push(element);
                      //   });
                      // });
                      list.push(this.getDxp(el.entityId, 1, index));
                      // BimSimConstructRoadwayList({
                      //   EntityId: el.entityId,
                      //   Level: 2,
                      // }).then((value) => {
                      //   value.data.data.forEach((element, index) => {
                      //     // if (index < 1) el.entityIdList.push(element);
                      //     element.Level = 2;
                      //     el.entityIdList.push(element);
                      //   });
                      // });
                    }
                  });

                  const listAll = await Promise.all(list);
                  setTimeout(() => {
                    let aarr = [];
                    res.data.data.forEach((el, index) => {
                      if (el.entityType == "roadway") {
                        if (el.entityIdList.length) {
                          el.entityIdList[0].entityType = el.entityType;
                        }
                        aarr = aarr.concat(
                          JSON.parse(JSON.stringify(el.entityIdList))
                        );
                      }
                    });
                    setTimeout(() => {
                      aarr.forEach((item) => {
                        this.animation.animationData.push({
                          id: item.id,
                          group: "laneGroup",
                          content: "",
                          // content: `${item.identity.split("-")[0]}-${
                          //   item.identity.split("-")[1]
                          // }`,
                          start: item.startTime,
                          end: item.endTime,
                          entityId: item.entityId,
                          entityType: aarr[0].entityType,
                          lane: item,
                          type: "point",
                          Level: item.Level,
                          // entityIdList: el.entityIdList,
                        });
                      });

                      setTimeout(async () => {
                        let list = [];
                        res.data.data.forEach((el, index) => {
                          el.entityIdList = [];
                          if (el.entityType == "roadway") {
                            // BimSimConstructRoadwayList({
                            //   EntityId: el.entityId,
                            //   Level: 2,
                            // }).then((value) => {
                            //   value.data.data.forEach((element, index) => {
                            //     element.Level = 2;
                            //     el.entityIdList.push(element);
                            //   });
                            // });
                            list.push(this.getDxp(el.entityId, 2, index));
                          }
                        });

                        const listAll = await Promise.all(list);
                        setTimeout(() => {
                          let aarr = [];
                          res.data.data.forEach((el, index) => {
                            if (el.entityType == "roadway") {
                              if (el.entityIdList.length) {
                                el.entityIdList[0].entityType = el.entityType;
                              }
                              aarr = aarr.concat(
                                JSON.parse(JSON.stringify(el.entityIdList))
                              );
                            }
                          });
                          setTimeout(() => {
                            aarr.forEach((item) => {
                              this.animation.animationData.push({
                                id: item.id,
                                group: "laneGroup",
                                content: "",
                                start: item.startTime,
                                end: item.endTime,
                                entityId: item.entityId,
                                entityType: aarr[0].entityType,
                                lane: item,
                                type: "point",
                                Level: item.Level,
                              });
                            });
                          }, 500);
                        }, 50);
                      }, 1000);
                    }, 500);
                  }, 0);
                }, 50);
              }, 200);
              setTimeout(() => {
                this.loading = false;
                console.log(this.$refs.programmeSimulation);
                this.programmeSimulationShow = true;
                this.$refs.programmeSimulation.getData();
              }, 300);
            }, 0);
          })
          .catch((err) => {});
      }
    },
    openTime() {
      let zhang = [
        {
          id: 4039215724217012,
          title: "A匝道完整模型",
          zhang: {
            totalTime: ["2023-06-01 00:00:00", "2024-07-15 00:00:00"],
            speed: 1,
            model: "3d3ef7a7-0b74-4c1b-8073-2db9960b3333",
            cameraView: {
              alt: 1484.5,
              heading: 264.7,
              lat: 26.10486145,
              lng: 107.39716777,
              pitch: -37.6,
            },
          },
          operate: [
            {
              i_icon: "el-icon-video-play",
              click: this.timeBlockPlay,
            },
          ],
          children: [
            {
              id: 3,
              title: "施工时区一",
              type: "新建",
              model: "3d3ef7a7-0b74-4c1b-8073-2db9960b3333",
              zhang: {
                totalTime: ["2023-06-02  00:00:00", "2023-07-02  00:00:00"],
                component: ["A匝道完整模型-A匝道桥-桥墩"],
              },
              operate: [],
            },
            {
              id: 4,
              title: "施工时区二",
              type: "拆除",
              model: "3d3ef7a7-0b74-4c1b-8073-2db9960b3333",
              zhang: {
                totalTime: ["2023-06-20  00:00:00", "2023-07-22  00:00:00"],
                component: ["A匝道完整模型-XLZD-A-XG"],
              },
              operate: [],
            },
            {
              id: 9,
              title: "施工时区二",
              type: "拆除",
              model: "3d3ef7a7-0b74-4c1b-8073-2db9960b3333",
              zhang: {
                totalTime: ["2023-06-20  00:00:00", "2023-07-22  00:00:00"],
                component: ["A匝道完整模型-XLZD-A-SG"],
              },
              operate: [],
            },
            {
              id: 5,
              title: "施工时区三",
              type: "新建",
              model: "3d3ef7a7-0b74-4c1b-8073-2db9960b3333",
              zhang: {
                totalTime: ["2023-07-25  00:00:00", "2023-08-15  00:00:00"],
                component: ["A匝道完整模型-A匝道桥-上部构造"],
              },
              operate: [],
            },
            {
              id: 6,
              title: "施工时区四",
              type: "新建",
              model: "3d3ef7a7-0b74-4c1b-8073-2db9960b3333",
              zhang: {
                totalTime: ["2023-08-15  00:00:00", "2023-09-15  00:00:00"],
                component: ["A匝道完整模型-A匝道桥-公用构造"],
              },
              operate: [],
            },
            {
              id: 7,
              title: "施工时区五",
              type: "新建",
              model: "3d3ef7a7-0b74-4c1b-8073-2db9960b3333",
              zhang: {
                totalTime: ["2023-09-15 00:00:00", "2023-10-15  00:00:00"],

                component: ["A匝道完整模型-A匝道桥-桥面系"],
              },
              operate: [],
            },
          ],
        },
      ];
      let animation, animationItem;
      animationItem = zhang.find((e) => e.id == 4039215724217012);
      animation = {
        groups: [
          {
            content: "施工模拟",
            id: "constructionSimulation",
          },
        ],
        animationData: [],
        initCustomDate: "",
        maxTime: "",
        programmeSimulationShow: false,
        loading: false,
      };
      animation.initCustomDate = animationItem.zhang.totalTime[0];
      animation.maxTime = animationItem.zhang.totalTime[1];
      animationItem.children.forEach((item) => {
        let end = item.zhang.totalTime[1];
        animation.animationData.push({
          content: `${animationItem.title}-${item.title}`,
          group: "constructionSimulation",
          id: item.id,
          start: item.zhang.totalTime[0],
          end,
          screenplay: [
            {
              id: item.id,
              type: item.type, // 是隐藏还是显示操作
              component: item.zhang.component, // 构件数组
              screenplayId: item.model,
            },
          ],
        });
      });
      this.animation.groups = animation.groups;
      this.animation.animationData = animation.animationData;
      this.initCustomDate = animation.initCustomDate;
      this.maxTime = animation.maxTime;
      this.programmeSimulationShow = true;
      this.programmeSimulationsInit();
    },
    programmeSimulationsInit() {
      console.log(this.animation.animationData, "this.animation.animationData");

      programmeSimulations.init();

      // this.animation.animationData.forEach((el) => {
      //   if (el.screenplay[0].type == "拆除") {
      //     programmeSimulations.init(
      //       this.modelID,
      //       el.screenplay[0].component,
      //       "拆除"
      //     );
      //   }
      // });
    },
    animationNodes(data) {
      console.log(data, "datadata***********");

      if (this.cross_group_type == "working") {
        //显示隐藏
        // this.datadata = data;
        // this.tilesetLayer = this.$GLOBAL.map.getLayer(
        //   "NewNode-cc89550f-8e0f-42c9-8d6d-9a78955cdf3f",
        //   "modelId"
        // );
        // console.log(this.tilesetLayer);
        //*******显示隐藏

        // if (tilesetLayer) {
        //   const conditions = [];

        //   for (let index = 0; index < showArr.length; index++) {
        //     const element = showArr[index];
        //     conditions.push([
        //       "${id} ==='" + element + "' ",
        //       "rgb(255, 255, 255,1)",
        //     ]);
        //   }
        //   conditions.push(["true", "rgba(255, 255, 255,0)"]);

        // tilesetLayer.style = new Cesium.Cesium3DTileStyle({
        //   color: {
        //     conditions: [["true", "rgba(255, 255, 255,0)"]],
        //   },
        // });
        // }

        //车流
        //注释

        // } else if (data.customDate.split(" ")[0] > "2024-01-01") {
        //   mapWork.init();
        // }
        //注释

        // if (this.mouseUpShow) {
        //   //拖动后再播放 mouseUpTime
        //   this.executeQueue = [];
        //   data.arrs.forEach((va) => {
        //     let d1 = new Date(va.start.split(/\s+/)[0]) * 1;
        //     let d2 = new Date(this.mouseUpTime.split(/\s+/)[0]) * 1;
        //     let time = (d2 - d1) / (1000 * 60 * 60 * 24);
        //     console.log(time, "timetimetimetimetimetime");
        //     va.timerIndex = time;
        //   });
        //   this.mouseUpShow = false;
        // }
        // let selectData = JSON.parse(JSON.stringify(data));
        // if (this.suspendedShow) {
        //   this.startCuttingFun();
        //   this.suspendedShow = false;
        //   return;
        // }
        // if (selectData.arrs.length) {
        //   if (this.initialization) {
        //     //初始化时
        //     selectData.arrs.forEach((el) => {
        //       clearInterval(el.timer);
        //       el.timer = null;
        //       el.timerIndex = 0;
        //     });
        //     this.colorHide("沿路线生长");
        //     this.executeQueue = [];
        //   }

        //   let list = [];
        //   if (selectData.add.length) {
        //     selectData.add.forEach((el) => {
        //       selectData.arrs.forEach((va) => {
        //         if (el == va.id) {
        //           if (!this.executeQueue.includes(va.id)) {
        //             list.push(va);
        //           }
        //         }
        //       });
        //     });
        //   }
        //   if (!list.length) return;
        //   this.initialization = false;
        //   this.executeQueue = [];
        //   // console.log(list, "list");
        //   this.executeQueue = this.executeQueue.concat(list);
        //   let end = selectData.arrs[0].end;
        //   let start = selectData.arrs[0].start;
        //   let overlap = false;
        //   selectData.arrs.forEach((el, index) => {
        //     //判断还需要优化
        //     if (index != 0 && el.start < end && el.end > end) {
        //       //表示当前组里面有重叠工期
        //       overlap = true;
        //     }
        //   });
        //   if (overlap) {
        //     //
        //   } else {
        //     //没重叠工期需要把上次的定时器清掉
        //     // if (this.timer.length) {
        //     //   this.timer.forEach((el) => {
        //     //     clearInterval(el);
        //     //   });
        //     // }
        //     // this.timer = [];
        //   }
        //   // 开始剖切
        //   this.startCuttingFun();
        // }
        // this.lastTimeGroup = selectData;
        //进入某一块的数据 BD-5-XJ
        console.log(data, "222222222");
        // this.trafficFlow();
        let addList = [];

        let newList = [];
        let deleteList = [];
        let new_finish_List = [];
        let delete_finish_List = [];

        addList = data.arrs.filter((item) => {
          return data.add.includes(item.id);
        });
        if (!addList.length) {
          data.arrs.forEach((item) => {
            addList.push(item);
          });
        }
        // var timeType =
        //   this.doubleSpeed == "day" ? 1 : this.doubleSpeed == "week" ? 7 : 30;

        addList.forEach((el) => {
          // el.screenplay[0].advanceTime = parseInt(
          //   this.DateMinus(el.start, el.end) / timeType
          // );
          console.log(el, "addList--elelelelelel");

          if (el.screenplay[0].type == "新建") {
            el.screenplay[0].component.forEach((va) => {
              newList.push(va);
            });
          } else if (el.screenplay[0].type == "拆除") {
            el.screenplay[0].component.forEach((va) => {
              deleteList.push(va);
            });
          }
        });
        programmeSimulations.componentDyeing(
          {
            newList,
            deleteList,
          },
          this.modelID,
          false
        );

        if (data.remove.length) {
          let removeList = data.items.filter((item) => {
            return data.remove.includes(item.id);
          });

          removeList.forEach((el) => {
            console.log(el, "removeList--elelelelelel");

            if (el.screenplay[0].type == "新建") {
              el.screenplay[0].component.forEach((va) => {
                new_finish_List.push(va);
              });
            } else if (el.screenplay[0].type == "拆除") {
              el.screenplay[0].component.forEach((va) => {
                delete_finish_List.push(va);
              });
            }
          });
          programmeSimulations.componentDyeing(
            {
              new_finish_List,
              delete_finish_List,
            },
            this.modelID,
            true
          );
          // removeList.forEach((el) => {
          //   programmeSimulations.componentDyeing(
          //     el.screenplay[0],
          //     el.screenplay[0].screenplayId,
          //     true
          //   );
          // });
        }
      } else {
        programmeSimulations.reset();
        setTimeout(() => {
          for (let i = 0; i < data.arrs.length; i++) {
            if (data.arrs[i].entityType != "roadway") {
              programmeSimulations.startDrawGraphic([
                [data.arrs[i].startLng, data.arrs[i].startLat],
                [data.arrs[i].endLng, data.arrs[i].endLat],
              ]);
            }
          }
        }, 100);
        let arr = "";
        setTimeout(() => {
          for (let i = 0; i < data.arrs.length; i++) {
            if (data.arrs[i].entityType == "roadway") {
              if (data.arrs[i].lane) {
                programmeSimulations.addDemoGraphic(data.arrs[i].lane);
                if (!arr.length) arr = data.arrs[i].lane.identity.split("-")[0];
              }
            }
          }
          this.$store.commit("sendStage", {
            arr,
            SimId: this.SimId,
          });
        }, 800);
      }

      // return;
      // if (testData[data.add[0]]) {
      //   console.log(testData[data.add[0]], "testData[data.add[0]]");

      //   if (data.type == "Drag") {
      //     programmeSimulations.reset();
      //     testData.forEach((el, index) => {
      //       if (index <= data.item[data.item.length - 1]) {
      //         programmeSimulations.startDrawGraphic(testData[index]);
      //       }
      //     });
      //   } else {
      //     data.arrs.forEach((el) => {
      //       // bimSimConstructObjectsDetail({
      //       //   EntityId: el.entityId,
      //       // }).then((res) => {});
      //       programmeSimulations.startDrawGraphic({
      //         start: [el.startLng, el.startLat],
      //         end: [el.endLng, el.endLat],
      //       });
      //     });
      //   }
      // } /BimSimConstructRoadway/list

      // console.log(data.arrs, "data.arrs");
      // for (let i = 0; i < data.arrs.length; i++) {
      //   if (data.arrs[i].entityType == "roadway") {
      //     if (data.arrs[i].lane) {
      //       arr.push(data.arrs[i].lane.identity.split("-")[0]);
      //       programmeSimulations.addDemoGraphic(data.arrs[i].lane);
      //     }
      //   } else {
      //     console.log(programmeSimulations.startDrawGraphic);
      //     programmeSimulations.startDrawGraphic([
      //       [data.arrs[i].startLng, data.arrs[i].startLat],
      //       [data.arrs[i].endLng, data.arrs[i].endLat],
      //     ]);
      //   }
      // }
    },
    async getDxp(id, Level, index) {
      await BimSimConstructRoadwayList({
        EntityId: id,
        Level: Level,
      }).then((value) => {
        value.data.data.forEach((element, i) => {
          element.Level = Level;
          this.entityList[index].entityIdList.push(element);
        });
      });
    },
    async getPoints(el, i) {
      await BimSimWorkingPointsDetailList({
        pointsId: el.pointsId,
      }).then((res) => {
        this.working_pointData[i].children[0].positiList = res.data.data;
      });
      await BimMlodelGetByWame({
        projectid: window.sessionStorage.getItem("nowProjectId"),
        modelName: el.code,
      }).then((res) => {
        // this.working_pointData[i].children[0].modelId = res.data.data.embsId;
        this.working_pointData[i].children[0].modelId = 4039215724217012;
      });
    },
    startCutting(el, i) {
      // let index = 0;
      // //每一组开始和结束日期相差多少天  7.55 秒 / 50 毫秒 = 151 次  x = (20 * 1800) / 1500 = 24
      let d1 = new Date(el.start.split(/\s+/)[0]) * 1;
      let d2 = new Date(el.end.split(/\s+/)[0]) * 1;
      let time = (d2 - d1) / (1000 * 60 * 60 * 24);
      let seconds = time * 50; //算出当前组时间线走完的时间，time是当前组开始和结束日期相差多少天，50是时间轴现在按照50毫秒前进一次
      let dynamicTime = parseInt(seconds / el.positiList.length); //

      // return;
      let tileSetPlanClip = cuttingMap.create_model_layer(el.modelId);

      let timer = setInterval(() => {
        if (el.timerIndex >= el.positiList.length) {
          if (el.simMethod == "沿路线拆除") {
            cuttingMap.colorHide(el.modelId);
          }
          clearInterval(el.timer);
          // el.timerIndex = el.positiList.length;
        }

        cuttingMap.addPlanClipThing(
          tileSetPlanClip,
          el.modelId,
          el.positiList[el.timerIndex],
          el.simMethod == "沿路线拆除" ? "oldRoad" : "newRoad"
        );
        el.timerIndex += 1;
      }, dynamicTime);
      // this.timer.push(timer);
      el.timer = timer;

      setTimeout(() => {
        // if (el.content == "新路-主线") {
        //   cuttingMap.colorShow(el.modelId);
        // } else {
        //   this.colorShow("沿路线生长");
        // }
        if (el.simMethod == "沿路线生长") {
          cuttingMap.colorShow(el.modelId);
        }
      }, dynamicTime);

      this.$once("hook:beforeDestroy", () => {
        // if (this.timer.length) {
        //   this.timer.forEach((el) => {
        //     clearInterval(el);
        //   });
        // }
      });
    },
    removeTimer() {
      //拖动时间轴
      // console.log("拖动拖动拖动拖动");
      if (this.executeQueue.length) {
        this.executeQueue.forEach((el) => {
          clearInterval(el.timer);
        });
      }
    },
    mouseUp(time) {
      // time 拖动到的时间
      this.mouseUpTime = time;
      this.mouseUpShow = true;
      this.suspendedShow = false;
    },
    suspended() {
      console.log("暂停暂停暂停暂停");
      //暂停
      this.suspendedShow = true;
      if (this.executeQueue.length) {
        this.executeQueue.forEach((el) => {
          clearInterval(el.timer);
        });
      }
      /////////////
    },
    resetTime() {
      // cuttingMap.getData(474882.172539734, 2888406.90142554, 963.891);
      // return;
      // 重置
      // if (this.timer.length) {
      //   this.timer.forEach((el) => {
      //     if (el.timer) clearInterval(el.timer);
      //   });
      // }
      // this.timer = [];
      console.log("重置重置重置重置");
      this.suspendedShow = false;
      // if (this.executeQueue.length) {
      //   this.executeQueue.forEach((el) => {
      //     clearInterval(el.timer);
      //     el.timer = null;
      //     el.timerIndex = 0;
      //   });
      // }
      cuttingMap.clearWJ();
      //初始化时
      // this.colorHide("沿路线生长");
      // this.colorShow("沿路线拆除");
      this.initialization = true;
      this.executeQueue = [];

      this.lastTimeGroup = null;
      this.timer = [];
      mapWork.init();
      this.programmeSimulationsInit();
    },
    startCuttingFun() {
      // console.log(this.executeQueue);
      this.executeQueue.forEach((el, index) => {
        if (el.positiList) {
          // if (el.simMethod == "沿路线生长") {
          //   this.colorHide("沿路线拆除");
          //   this.colorShow("沿路线生长");
          // }
          if (el.simMethod == "沿路线生长") {
            this.colorHide("沿路线拆除");
            // if (el.content == "新路-主线") {
            //   cuttingMap.colorShow(el.modelId);
            // } else {
            //   this.colorShow("沿路线生长");
            // }
          }
          if (!el.format) {
            //跳过positiList已经转换的经纬度
            el.positiList = this.redo(el.positiList);
          }
          el.format = true;
          if (!el.timerIndex) el.timerIndex = 0;
          if (!el.timer) el.timer = null;
          this.startCutting(el, index);
        }
      });
    },
    returnTimeFun(t) {
      console.log(t);
      if (t) {
        //注释
        // console.log(t);
        // const conditions = [];
        // let time = t.split(" ")[0];
        // console.log(time);
        // this.aaaaaa.forEach((el) => {
        //   if (time > el.start && time < el.end) {
        //     el.list.forEach((va) => {
        //       if (time > va.start && time < va.end) {
        //         conditions.push([
        //           "${id} ==='" + va.id + "' ",
        //           "rgb(255, 255, 255,1)",
        //         ]);
        //       }
        //     });
        //   }
        // });
        // conditions.push(["true", "rgba(255, 255, 255,0)"]);
        // this.tilesetLayer.style = new Cesium.Cesium3DTileStyle({
        //   color: {
        //     conditions: conditions,
        //   },
        // });
        //注释
        let time = t.split(" ")[0];
        if (time == "2023-07-01") {
          if (this.isPlaying) {
            this.isPlaying = false;
            setTimeout(() => {
              this.isPlaying = true;
              this.trafficFlow();
            }, this.silentTimeOutCounter);
          }
        }
        if (time == "2024-05-24") {
          mapWork.init();
        }
        if (time == this.project_startTime) {
          this.suspended();
        }
        // let time = t.split(" ")[0];
        // this.positionsAll.forEach((el) => {
        //   //增加
        //   let startTime = el.startTime.split(" ")[0];
        //   let endTime = el.endTime.split(" ")[0];

        //   if (time == startTime) {
        //     if (this.isPlaying) {
        //       this.isPlaying = false;

        //       // setTimeout(() => {
        //       //   this.isPlaying = true;
        //       // }, this.silentTimeOutCounter);
        //     }
        //   }
        //   //删除
        // });
      }
    },
    beginFun() {
      // setTimeout((res) => {
      //   this.animation.animationData.forEach((el) => {
      //     if (el.screenplay[0].type == "拆除") {
      //       console.log(el, "elelelelelelel");
      //       programmeSimulations.initialize(
      //         el.screenplay[0].component,
      //         el.screenplay[0].screenplayId
      //       );
      //     }
      //   });
      // }, 200);
      this.positionsAll = [];
      this.isPlaying = true;

      let new_finish_List = [];
      let delete_finish_List = [];
      this.animation.animationData.forEach((el) => {
        if (el.screenplay[0].type == "新建") {
          el.screenplay[0].component.forEach((va) => {
            delete_finish_List.push(va);
          });
        }
      });
      programmeSimulations.componentDyeing(
        {
          new_finish_List,
          delete_finish_List,
        },
        this.modelID,
        true
      );
    },
    trafficFlow() {
      let speedList = [120, 100, 80, 60];
      let intervalList = [1, 1.5, 2, 2.5];

      bimSimWorkingFlowDetail({
        simId: window.sessionStorage.getItem("crossGroupSimId"),
      }).then((res) => {
        console.log(res, "///////////////res////////////////////");
        for (let i = 0; i < 6; i++) {
          BimSimWorkingPointsDetailList({
            pointsId: res.data.data[i].pointsId,
            mod: 20,
          }).then((value) => {
            // console.log('res, "res"');
            console.log(value, "valuevalue");
            let arr = [];
            value.data.data.forEach((el) => {
              arr.push(el.split(","));
            });
            // console.log(arr);
            // console.log('****************');
            // console.log(Math.floor(Math.random() * (3 - 0 + 1)) + 0);

            // this.positionsAll.push({
            //   list: arr,
            //   speed: speedList[Math.floor(Math.random() * (3 - 0 + 1)) + 0],
            //   interval:
            //     intervalList[Math.floor(Math.random() * (3 - 0 + 1)) + 0],
            //   id: res.data.data[i].id,
            //   startTime: res.data.data[i].startTime,
            //   endTime: res.data.data[i].endTime,
            // });

            let positions = [
              {
                list: arr,
                speed: speedList[Math.floor(Math.random() * (3 - 0 + 1)) + 0],
                interval:
                  intervalList[Math.floor(Math.random() * (3 - 0 + 1)) + 0],
                id: res.data.data[i].id,
              },
            ];

            // console.log(positions, "positions");

            positions.forEach((el) => {
              console.log(el, "elelelelelelel");
              // mapWork.setVehicleSum(50); //小车总数
              mapWork.postAverageVelocity(el.speed); //平均速度
              mapWork.postIntervalvehicle(el.interval); //出车间隔
              let list = [];
              el.list.forEach((el) => {
                list.push(cuttingMap.getData(el[0], el[1], el[2]));
              });
              mapWork.simulationStart(list, el.id, true);
            });
          });
        }
        // res.data.data.forEach((el) => {
        //   BimSimWorkingPointsDetailList({
        //     pointsId: el.pointsId,
        //   }).then((res) => {
        //     // console.log('res, "res"');
        //     // console.log(res, "res");
        //     let arr = [];
        //     res.data.data.forEach((el) => {
        //       arr.push(el.split(","));
        //     });
        //     // console.log(arr);
        //     // console.log('****************');
        //     // console.log(Math.floor(Math.random() * (3 - 0 + 1)) + 0);

        //     let positions = [
        //       {
        //         list: arr,
        //         speed: speedList[Math.floor(Math.random() * (3 - 0 + 1)) + 0],
        //         interval:
        //           intervalList[Math.floor(Math.random() * (3 - 0 + 1)) + 0],
        //         id: el.id,
        //       },
        //     ];
        //     console.log(positions, "positions");

        //     positions.forEach((el) => {
        //       // mapWork.setVehicleSum(5); //小车总数
        //       mapWork.postAverageVelocity(el.speed); //平均速度
        //       mapWork.postIntervalvehicle(el.interval); //出车间隔
        //       mapWork.simulationStart(el.list, el.id, true);
        //       mapWork.simulationStart(el.list, el.id, true);
        //     });
        //   });
        // });
      });
    },

    DateMinus(date1, date2) {
      //date1:小日期   date2:大日期
      var sdate = new Date(date1);
      var now = new Date(date2);
      var days = now.getTime() - sdate.getTime();
      var day = parseInt(days / (1000 * 60 * 60 * 24));
      return day;
    },
    colorHide(type) {
      this.modelId_list.forEach((el) => {
        if (el.simMethod == type) {
          // console.log(el, "隐藏");

          cuttingMap.colorHide(el.modelId);
        }
      });
    },
    colorShow(type) {
      this.modelId_list.forEach((el) => {
        if (el.simMethod == type) {
          // console.log(el, "显示");
          cuttingMap.colorShow(el.modelId);
        } else {
        }
      });
    },
    deleteSimulation(e) {
      this.$confirm("是否删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          bimSimConstructDeeelt({
            // SceneId: this.sceneId, //场景ID
            SimId: e.id, //施工模拟Id
          }).then((res) => {
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.getData();
          });
        })
        .catch((err) => {
          console.log(err);
          // this.$message({
          //   type: "info",
          //   message: "已取消删除",
          // });
        });
    },
    editFun(e) {
      // programmeSimulations
      console.log(this.$GLOBAL.map.getCameraView());
    },
    shutDown() {
      programmeSimulations.reset();
      this.programmeSimulationShow = false;
    },
    redo(positiList) {
      // **************坐标转经纬度  别删别删别删别删 *******************
      let arr = cuttingMap.arrChange(2, positiList);
      let list = [];
      arr.forEach((el) => {
        if (el && el[0] && el[1]) {
          let str1 = el[0];
          let str2 = el[1];

          let sp1 = str1.split(",");
          let sp2 = str2.split(",");
          sp1[0] = Number(sp1[0]);
          sp1[1] = Number(sp1[1]);
          sp1[2] = Number(sp1[2]);

          sp2[0] = Number(sp2[0]);
          sp2[1] = Number(sp2[1]);
          sp2[2] = Number(sp2[2]);

          let a = this.GetPoint(sp1, sp2);
          list.push([
            cuttingMap.getData(a[0][0], a[0][1], 10),
            cuttingMap.getData(a[1][0], a[1][1], 10),
          ]);
        }
      });
      return list;

      // console.log(JSON.stringify(list));
      // **************坐标转经纬度  别删别删别删别删 *******************
      console.log("重置");
    },
    GetPoint(x1, x2) {
      let aa = this.GetAngle(x1, x2);
      var x = x1[0] + 1 * Math.cos(aa + Math.PI / 2);
      var y = x1[1] + 1 * Math.sin(aa + Math.PI / 2);

      var x2 = x1[0] + 1 * Math.cos(aa - Math.PI / 2);
      var y2 = x1[1] + 1 * Math.sin(aa - Math.PI / 2);
      return [
        [x, y],
        [x2, y2],
      ];
    },
    GetAngle(a, b) {
      var x = a[0] - b[0];
      var y = a[1] - b[1];
      var angle = Math.atan2(y, x);
      return angle;
    },
  },
  mounted() {
    this.workingShow = false;
    this.cross_group_type = window.sessionStorage.getItem("cross_group_type");
    this.getData();
    this.$eventBus.$on("shutDownTime", (res) => {
      this.modalNode.Timeline.head.fold.state = false;
      programmeSimulations.reset();
    });
    // setTimeout(() => {
    //   this.modalNode.Timeline.height = `${document.querySelector(
    //     "#mars3d-container"
    //   ).offsetHeight - 140}px`;
    // }, 10);

    programmeSimulations.createdGraphicLayer();

    cuttingMap.Initialization();
  },
  beforeDestroy() {
    programmeSimulations.reset();
  },
};
